module.exports = __webpack_public_path__ + "static/media/intransit1.65560f01.svg";